module.exports = __webpack_public_path__ + "static/media/denil.b8c1ef20.jpg";